import { getI18NMessage } from '../../../i18n/I18N';
import { initLoginPage } from '../reducers/LoginReducer';
import AppUtil, { getAppURL } from './../../../utils/AppUtil';
import UI_CONSTANTS from './../../app/constants/UIConstants';

export const initLoginComp = appHashPath => {
    return dispatch => {
        const isResetPassword = appHashPath && appHashPath.indexOf(UI_CONSTANTS.RESET_PW_URL_HASH) !== -1;
        const URL = `${getAppURL('LOGIN_LAYOUT')}${isResetPassword ? '?isResetPassword=Y' : ''}`;

        AppUtil.ajax( URL, undefined, response => {
            processLayout(response);
            
            dispatch( initLoginPage(response) );
        } )
    }
}

const renderCaptcha = (sitekey, setState, retryCount = 0) => {
    const maxRetries = 3;

    // Check if grecaptcha is available
    if (!window.grecaptcha) {
        if (retryCount < maxRetries) {
            setTimeout(() => renderCaptcha(sitekey, setState, retryCount + 1), 300);
        }
        return;
    }

    grecaptcha.ready(function () {
        // Check if container element exists
        const container = document.getElementById('captcha_wraper');
        if (!container) {
            if (retryCount < maxRetries) {
                // Container not ready, retry after a short delay
                setTimeout(() => renderCaptcha(sitekey, setState, retryCount + 1), 100);
            }
            return;
        }

        // Check if already rendered (avoid duplicate renders)
        if (container.hasChildNodes() && container.children.length > 0) {
            return;
        }

        const clientId = grecaptcha.render('captcha_wraper', {
            sitekey,
            badge: 'bottomleft',
            size: 'invisible'
        });

        setState({ reCaptchaClientId: clientId });
    });
}

export const loadCaptchaScript = (sitekey, setState) => {
    const scriptId = "recaptcha-script";

    const existingScript = document.getElementById(scriptId);
    if (existingScript) {
        document.head.removeChild(existingScript);
    }

    const script = document.createElement('script');
    script.id = scriptId;
    script.type = 'text/javascript';
    script.src = "https://www.recaptcha.net/recaptcha/api.js?render=explicit";
    script.defer = true;
    script.addEventListener("load", () => {
        renderCaptcha(sitekey, setState);
    });

    script.addEventListener("error", () => {
        setState({ captchaError: getI18NMessage("captchaScriptLoadError") });
    });

    document.head.appendChild(script);
}

export const validateCaptcha = (reCaptchaClientId, action, setState, callbackFn) => {
    setState({captchaError: undefined});
    
    if(window.grecaptcha) {
        grecaptcha.execute(reCaptchaClientId, { action })
            .then(recaptchaToken => {
                const URL = getAppURL('CAPTCHA_VALIDATION');

                AppUtil.ajax( URL, { recaptchaToken }, async response => {
                    if (response.status === 200) {
                        const responseJson = await response.json();
                        if(responseJson.valid) {
                            callbackFn();    
                        } else {
                            setState({ captchaError: getI18NMessage("invalidCaptcha") });
                        }
                    } else {
                        setState({ captchaError: getI18NMessage("errorValidatingCaptcha") });
                    }
                }, undefined, true);
            }, () => {
                setState({ captchaError: getI18NMessage("errorValidatingCaptcha") });
            }
        );   
    } else {
        setState({ captchaError: getI18NMessage("errorValidatingCaptcha") });
    }
}

export const processLayout = layoutConfig => {
    const { rightpanel, css } = layoutConfig;

    if ( rightpanel && rightpanel.length ) {
        rightpanel.filter( widget => widget.enabled ).forEach( widget => {
            if ( widget.id === UI_CONSTANTS.TWITTER_WIDGET ) {
                const scriptTag = document.createElement('script');

                scriptTag.src = "https://platform.twitter.com/widgets.js";
                scriptTag.setAttribute('charset', "utf-8")

                document.head.appendChild(scriptTag);
            } else if ( widget.id === UI_CONSTANTS.FACEBOOK_WIDGET ) {
                const scriptTag = document.createElement('script');

                scriptTag.src = "https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v18.0";
                scriptTag.setAttribute('crossorigin', "anonymous");
                scriptTag.setAttribute('nonce', "gNufjLz6");
                scriptTag.setAttribute('async', "");
                scriptTag.setAttribute('defer', "");

                document.head.appendChild(scriptTag);
            }
        } )
    }

    if ( css ) {
        const style = document.createElement('style');
        style.innerHTML = css;

        document.head.appendChild(style);
    }
}

export const validResetLink = callbackFn => {
    const resetDetails = location.pathname.replace('/auth/login/', '');

    AppUtil.ajax( getAppURL('VALID_RESET_PWD_LINK'), {
        details: resetDetails
    }, response => {
        callbackFn(response)
    } )
}
